// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type TelegramQueryVariables = Exact<{
  site: string;
  name: string;
}>;


export type TelegramQuery = { features: { id: string, isTelegramLoginActive: boolean | undefined } | undefined };


export const TelegramQueryDocument = gql`
    query TelegramQuery($site: String!, $name: String!) {
  features {
    id
    isTelegramLoginActive: isFlagActive(site: $site, name: $name)
  }
}
    `;